export enum ActionTabStep {
  Prev,
  Next
}

export const SWAP_ACTION_DEFAULT_TOTAL_STEPS = 3;
export const TRANSFER_ACTION_DEFAULT_TOTAL_STEPS = 1;
export const DEPOSIT_ACTION_DEFAULT_TOTAL_STEPS = 3;
export const WITHDRAW_ACTION_DEFAULT_TOTAL_STEPS = 6;
